import de from './de.json';
import en from './en.json';
import nl from './nl.json';

export const languages = {
    en,
    de,
    nl,
};
